export const exceptionsStatus = {
  active: 'active',
  archived: 'archived',
}
